import { DeductionDetailJson, createPromotionMatch } from "@/api/deduction.tsx"
import { classes } from "@/utils"
import { useState } from "preact/hooks"
import { toast } from "@/components/ui/use-toast.ts"
import { PromotionSelector, PromotionMatch } from "@/accounting_detail/PromotionSelector.tsx"
import { OpenPromotionLink } from "@/components/open_promotion_link.tsx"

interface DeductionPromotionFieldProps {
  deduction: DeductionDetailJson
  onUpdate: (updated: DeductionDetailJson) => void
  className?: string
}

export function DeductionPromotionField({ deduction, onUpdate, className }: DeductionPromotionFieldProps) {
  const [saving, setSaving] = useState(false)

  async function handleSelect(match: PromotionMatch) {
    setSaving(true)
    try {
      await createPromotionMatch({
        promotion_id: match.promotion.id,
        deduction_id: deduction.id,
      })
      onUpdate({
        ...deduction,
        promotion_id: match.promotion.id,
        promotion_name: match.promotion.name,
        promotion_remote_id: match.promotion.remote_promo_id,
      })
      toast({
        title: "Promotion linked",
        description: match.promotion.name,
      })
    } catch (error) {
      toast({
        title: "Failed to link promotion",
        description: error as Error,
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div class={classes("group relative", className)}>
      <div class="flex items-center justify-between gap-2 mb-1">
        <label class="text-gray-500 text-sm block">Matched Promotion</label>
        {deduction.promotion_id && <OpenPromotionLink promotion_id={deduction.promotion_id} />}
      </div>
      <div class={saving ? "opacity-50 pointer-events-none" : ""}>
        <PromotionSelector
          deductionId={deduction.id}
          selectedPromotionId={deduction.promotion_id}
          onSelect={handleSelect}
          searchContextSeed={{
            customer_name: deduction.customer_name,
            retailer_name: deduction.retailer_name,
            source: deduction.source,
            invoice_date: deduction.invoice_date,
            execution_date: deduction.execution_date,
          }}
        />
      </div>
    </div>
  )
}
